import { on } from "events";
import ExcelJS from "exceljs";

export const EXPORT_CAMPAGNES_COLUMNS = [
  { header: "Référence", key: "reference", width: 40 },
  { header: "Brouillon", key: "draft", width: 10 },
  { header: "Archivé", key: "shelve", width: 10 },
  { header: "Auteur", key: "auteur", width: 15 },
  { header: "Nom", key: "nom", width: 50 },
  { header: "Région", key: "region", width: 20 },
  { header: "Type Campagne", key: "typeCampagne", width: 20 },
  { header: "Objectif", key: "objectif", width: 50 },
  { header: "Date Début", key: "dateDebut", width: 15 },
  { header: "Durée (jours)", key: "dure", width: 15 },
  { header: "Estimation Éleveur", key: "estimationEleveur", width: 20 },
  { header: "Objectif Couverture (%)", key: "objectifCouverture", width: 20 },
  { header: "Date Création", key: "dateCreation", width: 20 },
  { header: "DDM", key: "ddm", width: 20 },
];

export function ExportToExcel({
  columns,
  rows,
  filename = "exportation-données",
  onSuccess,
  onError,
  onStart,
  onEnd,
}: {
  columns: any[];
  rows: any[];
  filename: string;
  onSuccess?: () => void;
  onError?: () => void;
  onStart?: () => void;
  onEnd?: () => void;
}) {
  try {
    if (onStart) onStart();
    // Créer un nouveau classeur Excel
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Campagnes");

    // Définir les colonnes
    worksheet.columns = columns;

    // Ajouter les données
    rows.forEach((item) => {
      worksheet.addRow(item);
    });

    // Formater l'en-tête
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFCCCCCC" },
    };

    // Ajuster les bordures
    worksheet.eachRow((row) => {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${filename ?? "données"}.xlsx`;
        link.click();
        if (onEnd) onEnd();
      })
      .catch((err) => {
        if (onEnd) onEnd();
      });
  } catch (error) {}
}
